<div class="notifications-overlay" [class.visible]="isVisible" (click)="onClose()">
  <div class="notifications-panel" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="notifications-header">
      <div class="d-flex align-items-center justify-center w-100">
        <div class="d-flex align-items-center">
          <img src="assets/svg/notification-bell-icon.svg" alt="Notificaciones" class="header-icon">
          <h3 class="header-title">Notificaciones</h3>
          @if(unreadCount > 0) {
            <span class="badge badge-primary ms-2">{{ unreadCount }}</span>
          }
        </div>
      </div>
    </div>

    <!-- Notifications List -->
    <div class="notifications-body">
      @if(notifications.length === 0) {
        <div class="no-notifications">
          <img src="assets/svg/notification-bell-icon.svg" alt="Sin notificaciones" class="no-notifications-icon">
          <h4>No tienes notificaciones</h4>
          <p>Cuando tengas nuevas notificaciones aparecerán aquí.</p>
        </div>
      } @else {
        @for(notification of notifications; track notification.id) {
          <div class="notification-item" 
               [class]="getNotificationClass(notification.type)"
               [class.unread]="!notification.isRead"
               (click)="markAsRead(notification)">
            
            <div class="notification-icon">
              <div>
                <img [src]="getNotificationIcon(notification.type)" alt="">
              </div>
            </div>

            <div class="notification-content">
              <div class="notification-header-item">
                <h4 class="notification-title">{{ notification.title }}</h4>
                <div class="d-flex align-items-center gap-2">
                  <span class="notification-time">{{ notification.timeAgo }}</span>
                </div>
              </div>
              <p class="notification-message">{{ notification.message }}</p>
            </div>
          </div>
        }
      }
    </div>

    <!-- Footer -->
    <div class="notifications-footer">
      <button class="btn-link text-semibold" (click)="onViewMore()">Ver más</button>
    </div>
  </div>
</div>